<template>
  <kst-section :title="Info.Section.InvoiceList.Title">
    <kst-table input-mode :data="invoiceList">
      <b-table-column
        v-slot="{ column, row }"
        cell-class="ks-col-shortdate"
        field="InvoiceDate"
        :label="RcpyInvCatalog.InvoiceDate.Label"
      >
        <kst-output boxOff field-only
          :field="column.field" :data="row" :catalog="RcpyInvCatalog"
        />
      </b-table-column>

      <b-table-column
        v-slot="{ column, row }"
        field="InvoiceID"
        :label="RcpyInvCatalog.InvoiceID.ColumnLabel"
      >
        <kst-output field-only
          :field="column.field" :data="row" :catalog="RcpyInvCatalog"
        />
      </b-table-column>

      <b-table-column
        v-slot="{ column, row }"
        field="ClientID"
        :label="RcpyInvCatalog.ClientID.Label"
      >
        <kst-output field-only
          :controlOff="row.ClientID === null"
          :field="column.field" :data="row" :catalog="RcpyInvCatalog"
        />
      </b-table-column>

      <b-table-column
        v-slot="{ column, row }"
        field="WarehouseID"
        :label="RcpyInvCatalog.WarehouseID.ColumnLabel"
      >
        <kst-output field-only
          :field="column.field" :data="row" :catalog="RcpyInvCatalog"
        />
      </b-table-column>

      <b-table-column numeric
        v-slot="{ column, row }"
        cell-class="ks-col-price"
        field="PaymentValue"
        :label="RcpyInvCatalog.PaymentValue.Label"
      >
        <kst-output field-only
          :field="column.field" :data="row" :catalog="RcpyInvCatalog"
        />
      </b-table-column>
    </kst-table>
  </kst-section>
</template>

<script>
import Info from "../RcpyInfo.js";
import RcpyInvCatalog from "../RcpyInvCatalog.js";

export default {
  props: {
    invoiceList: Array
  },
  data: () => ({
    Info: Info,
    RcpyInvCatalog: RcpyInvCatalog
  })
}
</script>